import axios from "../../../services/axios-config.js";

export async function getOpenCompanies() {
    const res = await axios.get('/admin/presence/open-companies');
    return res?.data;
}
